import React from 'react';
import { useTranslation } from 'react-i18next';

import { XIcon } from '@phosphor-icons/react';
import { getTranslation } from '../../utils';

import { CheckCircleIcon } from '@phosphor-icons/react';

export default function ProfileValidation({ close, orgPrefix, primaryColor }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-8 relative">
          {/* Close Button */}
          <button
            onClick={close}
            className="absolute top-4 left-4 text-gray-500 hover:text-gray-700">
            <XIcon size={24} />
          </button>

          {/* Content */}
          <div className="flex items-center justify-center mb-6">
            <CheckCircleIcon size={50} color={primaryColor || '#163F9B'} />
          </div>
          <div className="px-4">
            <h2
              className="heading mb-3 text-center font-bold text-xl"
              dangerouslySetInnerHTML={{
                __html: getTranslation(t, 'validationPopup.heading', orgPrefix)
              }}
            />
            <div
              className="text-center text-lg leading-relaxed"
              dangerouslySetInnerHTML={{
                __html: getTranslation(t, 'validationPopup.description', orgPrefix)
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
